import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getGuestNote = get('guest.note');

export const getAll = createSelector(getGuestNote, get('all'));

export const getMeta = createSelector(getGuestNote, get('meta'));

export const getFetching = createSelector(getGuestNote, get('fetching'));

export const getFetched = createSelector(getGuestNote, get('fetched'));

export const getSaving = createSelector(getGuestNote, get('saving'));

export const getSaved = createSelector(getGuestNote, get('saved'));

export const getDeleting = createSelector(getGuestNote, get('deleting'));
export const getDeleted = createSelector(getGuestNote, get('deleted'));
export const getDeletingError = createSelector(
  getGuestNote,
  get('deletingError')
);
